import { render, staticRenderFns } from "./xjgs.vue?vue&type=template&id=dd1f77c0&scoped=true"
import script from "./xjgs.vue?vue&type=script&lang=js"
export * from "./xjgs.vue?vue&type=script&lang=js"
import style0 from "./xjgs.vue?vue&type=style&index=0&id=dd1f77c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1f77c0",
  null
  
)

export default component.exports